import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { motion } from 'framer-motion';
import 'swiper/css';
import 'swiper/css/autoplay';
import './Service.css'; // Import our custom CSS

const brands = [
    { name: "Jaguar", img: "/assets/clients/client-03.png" },
    { name: "Dodge", img: "/assets/clients/client-04.png" },
    { name: "Ford", img: "/assets/clients/client-05.png" },
    { name: "Toyota", img: "/assets/clients/client-06.png" },
    { name: "Honda", img: "/assets/clients/client-01-2.png" },
];
const words = ['POPULAR', 'BRANDS']
const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.2,
            duration: 0.5,
            ease: 'easeOut',
        },
    }),
};
const BrandSlider = () => {
    return (
        <div className="client-brand-slider">
            <h2 className="client-slider-heading chakra-petch-bold">
                {words.map((word, i) => (
                    <motion.span
                        key={i}
                        custom={i}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={fadeInUp}
                        style={{ display: 'inline-block', marginRight: '0.5rem' }}
                    >
                        {word}
                    </motion.span>
                ))}
            </h2>
            <Swiper
                modules={[Autoplay]}
                spaceBetween={30}
                slidesPerView={3}
                loop={true}
                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    // when window width is >= 0px
                    0: {
                        slidesPerView: 1,
                    },
                    // when window width is >= 576px
                    576: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 992px
                    992: {
                        slidesPerView: 5,
                    },
                    // when window width is >= 1200px
                    1200: {
                        slidesPerView: 5,
                    },
                }}
                className="client-swiper-container"
            >
                {brands.map((brand, index) => (
                    <SwiperSlide key={index}>
                        <div className="client-slide-card">
                            <img src={brand.img} alt={brand.name} className="brand-logo" />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default BrandSlider;
